import { render, staticRenderFns } from "./AdminActions.vue?vue&type=template&id=c7d78b6a&scoped=true"
import script from "./AdminActions.vue?vue&type=script&lang=ts"
export * from "./AdminActions.vue?vue&type=script&lang=ts"
import style0 from "./AdminActions.vue?vue&type=style&index=0&id=c7d78b6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7d78b6a",
  null
  
)

export default component.exports